import type { Row } from "@tanstack/react-table"
import type { DateRange } from "react-day-picker"

export const filterFn = <T>(
  row: Row<T>,
  colId: string,
  // eslint-disable-next-line
  filterValue: any,
  date: boolean,
): boolean => {
  const value = row.getValue(colId)
  if (date) {
    if (filterValue == undefined) {
      return true
    } else {
      const range: DateRange = filterValue as DateRange
      if (range.from) {
        if (range.to) {
          return (value as Date) >= range.from && (value as Date) <= range.to
        } else {
          return value == range.from
        }
      }
    }
  } else {
    if (!Array.isArray(filterValue) || filterValue.length == 0) {
      return true
    } else {
      return filterValue.includes(value)
    }
  }
  return true
}
